<template>
  <div
    :title="noOfLines && text"
    :class="classes"
    :style="styles"
    @click="$emit('click')"
  >
    {{ bodyText }}
  </div>
</template>

<script>
export default {
  name: 'Label',
  props: {
    text: {
      type: [String, Number],
    },
    size: {
      type: String,
      default: undefined,
    },
    color: {
      type: String,
      default: undefined,
    },
    noTranslation: {
      type: Boolean,
      default: false,
    },
    bold: {
      type: Boolean,
      default: false,
    },
    textWrap: {
      type: Boolean,
      default: false,
    },
    underLine: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: undefined,
    },
    noOfLines: {
      type: [Number, String],
      default: undefined,
    },
  },
  computed: {
    classes() {
      const list = []
      if (this.color) {
        list.push(`${this.color}--text`)
      }
      if (this.bold) {
        list.push('font-weight-bold')
      }
      if (this.textWrap) {
        list.push('multi-line')
      }
      if (this.underLine) {
        list.push('under-line')
      }
      if (this.size) {
        list.push(this.convertSize(this.size))
      }
      if (this.noOfLines) list.push(`line-clamp-${this.noOfLines}`)
      return list
    },
    styles() {
      return {
        cursor: this.clickable && 'pointer',
      }
    },
    bodyText() {
      return this.text
    },
  },
  methods: {
    convertSize(size) {
      switch (size) {
        case 'h1':
          return 'display-4'
        case 'h2':
          return 'display-3'
        case 'h3':
          return 'display-2'
        case 'h4':
          return 'display-1'
        case 'h5':
          return 'headline'
        case 'h6':
          return 'title'
        case 'subtitle-1':
          return 'subtitle-1'
        case 'subtitle-2':
          return 'subtitle-2'
        case 'body-1':
          return 'body-1'
        case 'body-2':
          return 'body-2'
        case 'button':
          return 'button'
        case 'caption':
          return 'caption'
        case 'overline':
          return 'overline'
      }
    },
  },
}
</script>

<style scoped>
.under-line {
  text-decoration: underline;
}
div.multi-line {
  white-space: pre-wrap;
  word-wrap: break-word;
}

/* vuetifyより */
.button {
  font-weight: 500;
  font-size: 0.875rem;
  letter-spacing: 0.0892857143em;
}

/* clamp */
.line-clamp-1 {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.line-clamp-4 {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.line-clamp-5 {
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.line-clamp-6 {
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
